<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Approve/Reject Pending Approval
      Requests</a>
  </div>
  <div>
    <div *ngIf="filteredPendingApprovalRequests.length != 0 && !loading">
      <table class="pure-table pure-table-horizontal">
        <thead>
        <tr>
          <th>Business Use Case</th>
          <th>From Country Code</th>
          <th>Level Of Data</th>
          <th>Transit Time Type</th>
          <th>File Version</th>
          <th>Request Status</th>
          <th>Request Type</th>
          <th>Approval Type</th>
          <th>Created By</th>
          <th>Creation Time(UTC)</th>
          <th>Last Updated By</th>
          <th>Last Updated Time(UTC)</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let _row of filteredPendingApprovalRequests">
          <td>
            {{_row.businessUseCase != null ? _row.businessUseCase : "N/A"}}
          </td>
          <td>
            {{_row.fromCountryCode != null ? _row.fromCountryCode : "N/A"}}
          </td>
          <td>
            {{_row.componentKeyValue != null ? _row.componentKeyValue : "N/A"}}
          </td>
          <td>
            {{ _row.transitTimeType != null ? _row.transitTimeType : "N/A"}}
          </td>
          <td>
            {{ _row.timestamp != null ? _row.timestamp  : "N/A"}}
          </td>
          <td>
            {{_row.requestStatus != null ? _row.requestStatus : "N/A"}}
          </td>
          <td>
            {{_row.requestType != null ? _row.requestType : "N/A"}}
          </td>
          <td>
            {{_row.approvalType != null ? _row.approvalType : "N/A"}}
          </td>
          <td>
            {{ _row.createdBy != null ?  _row.createdBy: "N/A"}}
          </td>
          <td>
            {{ _row.timestamp != null ? this.commonUtils.convertToDate(_row.timestamp) : "N/A"}}
          </td>
          <td>
            {{ _row.lastUpdatedBy != null ?  _row.lastUpdatedBy: "N/A"}}
          </td>
          <td>
            {{ _row.lastUpdatedTime != null ? this.commonUtils.convertToDate(_row.lastUpdatedTime) : "N/A"}}
          </td>

          <td>
            <!-- Get data Buttons-->
            <div
              class="btn-group" role="group"
              aria-label="...">
              <button class="btn btn-primary btn-sm" (click)="onReviewButtonClick(_row, true)" type="button">
                Approve
              </button>
              <button class="btn btn-danger btn-sm" (click)="onReviewButtonClick(_row, false)" type="button">
                Reject
              </button>
            </div>

          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Display message when the table is empty -->
    <div *ngIf="filteredPendingApprovalRequests.length == 0 && !loading">
      <h2>There are no pending requests for approval.</h2>
    </div>
    <app-loader [loading]="loading" [size]="'small'"></app-loader>
    <div>
      <button class="pure-button pure-button-primary button-large" (click)="render()">
        Reload
      </button>
    </div>


  </div>
</div>
